(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    


function cart_spin()
{

$( ".custom-spinner" ).spinner({
min: 1
});

}

$(document)	
.on( 'shopify:section:select', cart_spin )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    

function prceload() {

  $(function() {

    $('.minamount').val('0');

    $('.maxamount').val('0');


    var cursbl = String(

      $("#product_collection .product_price")

        .find(".price")

        .find('.money')

        .eq(0)

        .text()

        .replace(/-?[0-9]*\.?[0-9]+/, "")

    );


    var prices = [];


    $("#product_collection .product_price").each(function() {

      var price2 = parseInt(

        $(this).data('price'),

        10

      );

      prices.push(price2);

    });


    $("#product_collection .product_price")

      .find(".price")

      .each(function() {

        var number = Number(

          $(this)

            .find('.money')

            .eq(0)

            .text()

            .replace(/[^0-9\.-]+/g, "")

        );


        var price2 = parseInt(

          number,

          10

        );


        prices.push(price2);


        $(this)

          .closest(".product_price")

          .data('price', price2);

      });


    prices.sort(function(a, b) {

      return a - b;

    });


    var low = Math.min.apply(

      Math,

      prices

    );


    var high = Math.max.apply(

      Math,

      prices

    );


    slider_updt(

      low,

      high,

      cursbl

    );


    $("#search-price").click(function() {

      var min = $('.minamount').data('prod_price_min'),

          max = $('.maxamount').data('prod_price_max');


      showProducts(

        min,

        max

      );

    });


  });

}


$(document)

  .on(

    'shopify:section:load',

    prceload

  );


/* =========================================================
   "SORT BY" PLACEHOLDER OPTION INSIDE THE DROPDOWN
   ========================================================= */

function addSortByPlaceholder() {

  var $sortSelect = $('#SortBy');

  if (!$sortSelect.length) {
    return;
  }

  if (!$sortSelect.find('option[value=""]').length) {

    $sortSelect.prepend(
      '<option value="" selected disabled hidden>Sort by</option>'
    );

  }

  if ($sortSelect.val() === '' || $sortSelect.val() === null) {
    $sortSelect.removeClass('has-value');
  } else {
    $sortSelect.addClass('has-value');
  }

  $sortSelect.off('change.sortbyplaceholder').on('change.sortbyplaceholder', function () {

    if ($(this).val() === '') {
      $(this).removeClass('has-value');
    } else {
      $(this).addClass('has-value');
    }

  });

}


$(document).ready(function () {
  addSortByPlaceholder();
});


$(document).on('shopify:section:load', function () {
  addSortByPlaceholder();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-about"] && !Shopify.designMode) return;
  try {
    
jQuery(function($) {
		$('#wcu').sss({
			slideShow : true,
			showNav : true
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product"] && !Shopify.designMode) return;
  try {
    
/* jquery for section load */
function ftrload() {
  $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 

        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {

        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }


      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
 
  }


$(document)
 .on( 'shopify:section:load', ftrload )
;
/* ends */

  $(document).ready(function() {
    $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      
     links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });
$( document ).ready(function() {
  (function($){
    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 
        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {
        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }

    $(window).load(function() {
      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
    });
  })(jQuery);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slider"] && !Shopify.designMode) return;
  try {
    

(function() {

  /* =======================================================
     SLIDESHOW
     ======================================================= */

  function initSlideshow() {

    var container = document.getElementById(
      'custom-slideshow-{{ section.id }}'
    );

    if (!container) {
      return;
    }


    var slides = container.querySelectorAll(
      '.custom-slide'
    );

    if (!slides.length) {
      return;
    }


    var current = 0;


    function showSlide(index) {

      if (index >= slides.length) {
        index = 0;
      }


      slides.forEach(function(slide) {

        slide.classList.remove('active');

      });


      slides[index].classList.add('active');

      current = index;

    }


    showSlide(0);


    /* =====================================================
       AUTOMATIC SLIDESHOW
       ===================================================== */

    if (slides.length > 1) {

      setInterval(function() {

        showSlide(current + 1);

      }, 8000);

    }

  }


  /* =======================================================
     CLICKABLE SCROLL BUTTON
     ======================================================= */

  function initScrollButton() {

    var button = document.querySelector(
      '#custom-slideshow-{{ section.id }} .scroll-down-indicator'
    );

    if (!button) {
      return;
    }


    /* Prevent duplicate initialization */

    if (button.dataset.scrollInitialized === 'true') {
      return;
    }


    button.dataset.scrollInitialized = 'true';


    /* =====================================================
       CLICK
       ===================================================== */

    button.addEventListener(
      'click',
      function(event) {

        event.preventDefault();

        event.stopPropagation();


        window.scrollBy({

          top: window.innerHeight * 0.85,

          left: 0,

          behavior: 'smooth'

        });

      },
      false
    );


    /* =====================================================
       MOBILE TOUCH
       ===================================================== */

    button.addEventListener(
      'touchend',
      function(event) {

        event.preventDefault();

        event.stopPropagation();


        window.scrollBy({

          top: window.innerHeight * 0.85,

          left: 0,

          behavior: 'smooth'

        });

      },
      {
        passive: false
      }
    );

  }


  /* =======================================================
     INITIALIZE EVERYTHING
     ======================================================= */

  function initializeEverything() {

    initSlideshow();

    initScrollButton();

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeEverything
    );

  } else {

    initializeEverything();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function(event) {

      if (
        event.detail &&
        event.detail.sectionId ===
        '{{ section.id }}'
      ) {

        setTimeout(
          initializeEverything,
          100
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

$(document)	
 .on( 'shopify:section:select', prod_tabload )
;

  } catch(e) { console.error(e); }
})();
})();
